// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Message content category IDs (same as in `bank_config.fbs`).
 */
export enum MessageCategory {
  NONE = 0,
  Status = 1,
  Traffic = 2,
  Usage = 3,
  Service = 4,
  Control = 5,
  Fault = 6,
  GroupSupervisoryStatus = 7,
  GroupControl = 8,
  ControllerInfo = 9,
}
